module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/contracts/admin-contract-detail.component.scss
// module id = ./src/app/admin/contracts/admin-contract-detail.component.scss
// module chunks = main